import React, { useMemo, useCallback, useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Dropdown } from 'primereact/dropdown'

import { sortOptions } from '@aytm/app/insights/dashboard/lib/filters'

import './ButtonSelector.scss'

const CLASS = 'insights-portal-button-selector'

const ButtonSelector = props => {
  const inputRef = useRef()

  const [panelStyle, setPanelStyle] = useState(null)

  const options = useMemo(
    () => (props.sort ? sortOptions(props.options) : props.options || []),
    [props.options, props.sort]
  )

  const onChange = event => {
    if (props.onChange) {
      props.onChange({ value: event.value })
    }
  }

  const valueTemplate = useCallback(() => props.label || props.children || '', [props.children, props.label])

  useEffect(() => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect()
      setPanelStyle({ width: `${rect.width}px` })
    }
  }, [])

  return (
    <Dropdown
      confirmKeyboardSelect
      className={`insights-portal ${CLASS}${props.className ? ` ${props.className}` : ''}${
        props.invalid ? ` ${CLASS}-invalid` : ''
      }`}
      panelClassName="insights-portal PRAYTMTheme"
      panelStyle={panelStyle}
      inputRef={inputRef}
      appendTo={document.body}
      options={options}
      optionLabel={'name'}
      valueTemplate={valueTemplate}
      filter={options.length > 10}
      resetFilterOnHide={true}
      filterPlaceholder="Search items"
      disabled={props.disabled}
      onChange={onChange}
    />
  )
}

ButtonSelector.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.any,
  children: PropTypes.any,
  options: PropTypes.arrayOf(PropTypes.object),
  filter: PropTypes.any,
  sort: PropTypes.any,
  disabled: PropTypes.any,
  invalid: PropTypes.any,
  onChange: PropTypes.func
}

export default ButtonSelector
